<template>
  <div class="css-scenario-list">
    <CSSTitleLink :title-text="muzikListenTitle" :title-link="muzikListenURL" />
    <div ref="scenarios" class="scenario-list">
      <div class="list">
        <div v-for="scenario in scenarioList" :key="scenario.id" :class="textPositionClass" class="item">
          <div v-if="!loaded" class="skeleton-cover2 cover">
            <!--  -->
          </div>
          <a v-if="loaded && scenario.id"
             v-cover-loader
             :data-src="scenario.file_cover_link"
             :data-default-src="'/img/img-default/img-scenario-default.jpg'"
             :aria-label="displayLocaleTitle(scenario)"
             :href="scenarioHref(scenario)" target="_blank"
             class="cover" @click="scenarioOnClick(scenario)"
          >
            <!--  -->
          </a>
          <div :class="textPositionClass" class="subject">
            <a v-if="loaded" :href="scenarioHref(scenario)" target="_blank" class="link-text" @click="scenarioOnClick(scenario)">
              {{ displayLocaleTitle(scenario) }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoverLoader from '@/directives/CoverLoader'
import ScenarioService from '@/assets/services/ScenarioService'
import { displayLocaleTitle } from '@/assets/helpers/ScenarioHelper.js'
import CSSTitleLink from '@/components/css-web/CSSTitleLink'

export default {
  name: 'CSSScenarioList',
  components: {
    CSSTitleLink
  },
  directives: {
    CoverLoader
  },
  props: {
    textPosition: {
      type: String,
      default: 'OUTSIDE' // OUTSIDE, INSIDE
    },
    placeholderNum: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      loaded: false,
      scenarioIdList: [
        '8bab9360-7edb-46c5-9aa7-7e4182cd7736', // 知名作曲家
        '8bab9370-864f-48f8-81bf-db3decb14028', // Top 10 播放清單
        '8bab9382-4efe-4ebf-8b30-812f13d4c729', // 樂器
        '8bab9353-8e2e-4807-8797-642627d90e73', // 舒壓
        '8bab933a-a935-4548-8ee5-421f9220d4d5', // 工作
        '8bab932c-d298-4361-8d2d-abbf44358b06', // 閱讀
        '8bab9385-a23d-4b87-a067-d6f33f381c6b', // 電視影劇
        '8bab9372-0c7d-460f-8aae-46f218ab9677' // 浪漫時期
      ],
      scenarioList: []
    }
  },
  computed: {
    textPositionClass() {
      return this.textPosition.toLowerCase() // inside or outside
    },
    muzikListenURL() {
      return `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    muzikListenTitle() {
      return this.$i18n.t('CSS.LISTEN_TITLE')
    }
  },
  created() {
    // initial empty data
    for (let i = 0; i < this.placeholderNum; i++) {
      this.scenarioList.push({ loaded: false })
    }
    this.getScenarioList()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    displayLocaleTitle,
    displayScenarioCover(scenario) {
      return { 'background-image': `url(${scenario.file_cover_link})` }
    },
    scenarioHref(scenario) {
      return scenario && scenario.id
        ? `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/scenarios/${scenario.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    scenarioOnClick(scenario) {
      // console.log(`Scenario ${scenario.id} on click.`)
    },
    async getScenarioList() {
      let scenarioList = []
      if (this.scenarioIdList && this.scenarioIdList.length === 0) {
        scenarioList = await ScenarioService.getScenariosList(null, null, 1, 8)
      } else {
        const q = {
          'id': this.scenarioIdList
        }
        scenarioList = await ScenarioService.getScenariosList(q)
      }
      if (scenarioList && scenarioList.data) {
        this.scenarioList = scenarioList.data
      }
      this.loaded = true
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/variables.scss';
.css-scenario-list {
  .title {
    margin: 16px 0;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.63;
    letter-spacing: normal;
    color: $grey-50;

    .linker {
      float: right;
      font-size: 20px;
      font-weight: normal;
      line-height: 39px;
      transition: color .4s ease;
      cursor: pointer;
      > i {
        float: right;
        font-size: 24px;
        line-height: 39px;
      }
      @include default-link-hover($grey-50)
    }
  }
  .list {
    display: block;
    margin: 0 -18px;
    .item {
      position: relative;
      display: inline-block;
      width: calc(25% - 36px);
      margin: 0 18px;
      // text-decoration: none;
      &.outside {
        margin-bottom: 24px;
      }
      &.inside {
        margin-bottom: 36px;
      }
      .cover {
        display: block;
        padding-top: 89%;
        border-radius: 12px;
        background-color: $grey-ec;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        cursor: pointer;
      }
      .subject {
        width: 100%;
        text-align: center;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .link-text {
          color: inherit;
          text-decoration: none;
          cursor: pointer;
        }
        &.outside {
          height: 32px;
          margin-top: 12px;
          font-size: 20px;
          line-height: 1.6;
          letter-spacing: -0.1px;
          color: $grey-50;
        }
        &.inside {
          position: absolute;
          bottom: 15%;
          height: 26px;
          padding: 0 16px;
          font-size: 16px;
          font-weight: 700;
          line-height: 1.63;
          color: #ffffff;
        }
      }
    }
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .css-scenario-list {
    .list {
      margin: 0 -12px;
      .item {
        width: calc(50% - 24px);
        margin: 0 12px;
        &.outside,
        &.inside {
          margin-bottom: 24px;
        }
        .subject {
          margin: 8px 0;
          font-size: 16px;
          line-height: 1.63;
          color: $grey-7d;
        }
      }
    }
  }
}

</style>
